export default "__VITE_ASSET__DIm$n$i6__"